import { TranslationLocales } from './';

type ITranslationFunction = {
  [key in InsuranceTranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

export type InsuranceTranslationKeys =
'whatWillYouDoIfThisHappen'|
'youBecomeInjuredOrIll'|
'theStaffCanNotUnderstandYourLanguage'|
'yourPassportOrCreditCardIsLostStolen'|
'youCanFeelRelievedWithJapanTravelInsurance';

export const insuranceTranslations: {
  [locale in TranslationLocales]: ITranslationFunction
} = {
  'en': {
    whatWillYouDoIfThisHappen: () => ('What will you do if this happen?'),
    youBecomeInjuredOrIll: () => ('You become injured or ill...'),
    theStaffCanNotUnderstandYourLanguage: () => ('The staff can\'t understand your language...'),
    yourPassportOrCreditCardIsLostStolen: () => ('You passport or credit card is lost/stolen...'),
    youCanFeelRelievedWithJapanTravelInsurance: () => ('Feel secure by being covered by Japan Travel Insurance!!'),
  },
  'ja': {
    whatWillYouDoIfThisHappen: () => ('こんな時、どうしますか？'),
    youBecomeInjuredOrIll: () => ('ケガ・病気になった...'),
    theStaffCanNotUnderstandYourLanguage: () => ('言葉が通じない...'),
    yourPassportOrCreditCardIsLostStolen: () => ('パスポートを紛失した...'),
    youCanFeelRelievedWithJapanTravelInsurance: () => ('日本旅行保険に加入すれば安心!!'),
  },
  'zh-CN': {
    whatWillYouDoIfThisHappen: () => ('出现这种情况时该怎么办？'),
    youBecomeInjuredOrIll: () => ('生病或受伤了...'),
    theStaffCanNotUnderstandYourLanguage: () => ('语言不通...'),
    yourPassportOrCreditCardIsLostStolen: () => ('护照丢失了...'),
    youCanFeelRelievedWithJapanTravelInsurance: () => ('购买日本旅行保险，让您安心享受旅行乐趣！'),
  },
  'zh-HK': {
    whatWillYouDoIfThisHappen: () => ('發生這種狀況時該怎麼辦？'),
    youBecomeInjuredOrIll: () => ('生病或受傷...'),
    theStaffCanNotUnderstandYourLanguage: () => ('語言不通...'),
    yourPassportOrCreditCardIsLostStolen: () => ('護照遺失...'),
    youCanFeelRelievedWithJapanTravelInsurance: () => ('買埋日本旅行保險就安心晒！'),
  },
  'zh-TW': {
    whatWillYouDoIfThisHappen: () => ('發生這種狀況時該怎麼辦？'),
    youBecomeInjuredOrIll: () => ('生病或受傷...'),
    theStaffCanNotUnderstandYourLanguage: () => ('語言不通...'),
    yourPassportOrCreditCardIsLostStolen: () => ('護照遺失...'),
    youCanFeelRelievedWithJapanTravelInsurance: () => ('只要投保日本旅遊保險就不用擔心!!'),
  },
};
